export default __webpack_public_path__ + "static/media/minimum-age.0037de29.svg";